import { useCheckoutConsentReminder } from "@jti/commerce";
import { useGetUserConsentsQuery } from "@jti/store/slices/profileApiSlice";

import { useCheckoutV2Configuration } from "@checkout-v2/shared/providers/CheckoutV2ConfigurationProvider";

export const useConsentPopUp = () => {
  const checkoutConfig = useCheckoutV2Configuration();
  const { consentReminderPopup } = checkoutConfig || {};

  const consentsQuery = useGetUserConsentsQuery("all");
  return useCheckoutConsentReminder(consentReminderPopup, consentsQuery);
};
